import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import {
  Eye,
  Trash,
  Plus,
  ArrowsClockwise,
  Pencil,
} from "@phosphor-icons/react";
import { Gear } from "@phosphor-icons/react/dist/ssr";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: TableAction.CREATE,
      label: "create",
      showLabel: true,
      allowed: true,
      show: true,
      action: null,
      icon: <Plus size={20} />,
      roles: ["admin"]
    },
  ],
  rowActions: [
    {
      name: RowAction.EDIT,
      label: "edit",
      icon: <Pencil size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("edit", element);
      },
      roles: ["admin"]
    },
    {
      name: RowAction.DELETE,
      label: "delete",
      icon: <Trash size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("delete", element);
      },
      roles: ["admin"]
    },
    {
      name: RowAction.DETAILS, 
      label: 'details',
      icon: <Eye size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => { 
        console.log('details', element);
      },
      roles: ["admin", "guide"]
    },
    {
      name: 'generate-assignments', 
      label: 'generate-assignments',
      icon: <Gear size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => { 
        console.log('generate-assignments', element);
      },
      roles: ["admin"]
    }
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      allowOrder: true,
    },
    {
      name: "name",
      label: "name",
      key: "name",
      type: "string",
      show: true,
      allowOrder: true,
    },
    {
      name: "start_date",
      label: "start_date",
      key: "start_date",
      type: "date",
      show: true,
      allowOrder: true,
    },
    ,
    {
      name: "end_date",
      label: "end_date",
      key: "end_date",
      type: "date",
      show: true,
      allowOrder: true,
    },
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const {
    getFunction,
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
    detailsFunction,
    initializeGenerateAssignmentsFunction,
  } = functions;
  tableConfig.actions[0].action = () => initializeFunction();
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any) => getFunction(id);
  tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
  tableConfig.rowActions[2].action = (id: any) => detailsFunction(id);
  tableConfig.rowActions[3].action = (id: any) => initializeGenerateAssignmentsFunction(id);
  return tableConfig;
};
export default getConfig;
